import React from 'react';

const Modal = ({ isOpen, onClose, title, children, size = 'lg' }) => {
    if (!isOpen) return null;

    const sizeClasses = {
        sm:   'max-w-sm',
        md:   'max-w-md',
        lg:   'max-w-lg',
        xl:   'max-w-xl',
        '2xl':'max-w-2xl',
        '3xl':'max-w-3xl',
        '4xl':'max-w-4xl',
        '5xl':'max-w-5xl',
        '6xl':'max-w-6xl',
        '7xl':'max-w-7xl',
        full: 'max-w-[95vw]'
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[2px] transition-opacity print:absolute print:inset-0 print:bg-transparent print:backdrop-blur-none">
            <div className={`bg-erp-surface rounded-erp-xl shadow-erp-modal border border-erp-border w-full ${sizeClasses[size] || 'max-w-lg'} mx-4 overflow-hidden print:shadow-none print:w-full print:max-w-full print:mx-0 print:border-none print:rounded-none`}>
                {title && (
                    <div className="px-6 py-4 border-b border-erp-border flex justify-between items-center bg-erp-surface-2 print:hidden">
                        <h3 className="text-base font-semibold text-erp-text">{title}</h3>
                        <button
                            onClick={onClose}
                            className="p-1 rounded-lg text-erp-text-3 hover:text-erp-danger hover:bg-erp-danger-bg transition-colors"
                            aria-label="Close modal"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.75}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                )}
                {!title && (
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 p-1 rounded-lg text-erp-text-3 hover:text-erp-danger hover:bg-erp-danger-bg transition-colors z-[60] print:hidden"
                        aria-label="Close modal"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.75}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                )}
                <div className="px-6 py-5 max-h-[75vh] overflow-y-auto print:max-h-none print:overflow-visible print:px-0 print:py-0 print:block">
                    {children}
                </div>
            </div>

            {/* Global print styles to ensure body height expands for pagination */}
            <style dangerouslySetInnerHTML={{
                __html: `
                @media print {
                    html, body {
                        height: auto !important;
                        overflow: visible !important;
                    }
                }
            ` }} />
        </div>
    );
};

export default Modal;
